import { createPropertySelectors, createSelector, Selector } from "@ngxs/store";
import { JOBS_STATE_TOKEN, JobsState, JobsStateModel } from "./state";
import { Job } from "@dis/models";

export class JobsSelectors {
  static slices = createPropertySelectors<JobsStateModel>(JobsState);

  static getByBillingStatus(billingStatus: string) {
    return createSelector([JobsSelectors.slices.items], (items: Job[]) => {
      return items.filter((job) => job.billing!.status === billingStatus);
    });
  }

  static getByProjectNumber(projectNumber: string) {
    return createSelector([JobsSelectors.slices.items], (items: Job[]) => {
      return items.filter((job) => job.projectNumber === projectNumber);
    });
  }

  static getByQuoteNumber(quoteNumber: string) {
    return createSelector([JOBS_STATE_TOKEN], (state: JobsStateModel) => {
      return state.items.filter((job) => job.jobNumber?.includes(quoteNumber));
    });
  }

  static getRecentByDate(status: string, amount: number) {
    const getDateTime = (inputDate: Date | null | undefined) => {
      return inputDate != null ? new Date(inputDate).getTime() : 0;
    };
    return createSelector([JobsState.getByStatus(status)], (jobs: Job[]) => {
      return status === "SHIPPED"
        ? jobs
            .sort(
              (a, b) =>
                getDateTime(b.dates!.shipmentDates![b.dates!.shipmentDates!.length].start) -
                getDateTime(a.dates!.shipmentDates![a.dates!.shipmentDates!.length].start)
            )
            .slice(0, amount)
        : jobs
            .sort(
              (a, b) =>
                getDateTime(b.dates!.shipmentDates![b.dates!.shipmentDates!.length].stop) -
                getDateTime(a.dates!.shipmentDates![a.dates!.shipmentDates!.length].stop)
            )
            .slice(0, amount);
    });
  }

  @Selector([JOBS_STATE_TOKEN])
  static getByUid(state: JobsStateModel) {
    return (uid: string) => {
      return state.items.find((job) => job.uid === uid);
    };
  }

  /**
   *
   * @description Lazy version of the selector to work with signals
   * @param state
   * @returns
   */
  @Selector([JOBS_STATE_TOKEN])
  static getByJobNumber(state: JobsStateModel) {
    return (jobNumber: string) => {
      return state.items.filter((job) => job.jobNumber === jobNumber);
    };
  }
}
